import BaseAddEditModal from '../../components/base/BaseAddEditModal';
import React from 'react';

const AddEditMaintainenceModal = ({ isEdit, isOpen, onClose, initialData, onSave }) => {
  const dataStructure = {
    start_date: { type: 'dateTime', label: 'Start Date', required: true },
    end_date: { type: 'dateTime', label: 'End Date', required: true },
  };

  return (
    <BaseAddEditModal
      isOpen={isOpen}
      isEdit={isEdit}
      onClose={onClose}
      initialData={initialData}
      onSave={onSave}
      dataStructure={dataStructure}
      tableName="maintenance"
    />
  );
};
export default AddEditMaintainenceModal;










